import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "actiondescriptor"
    }}>{`ActionDescriptor`}</h1>
    <h2 {...{
      "id": "indexable"
    }}>{`Indexable`}</h2>
    <p>{`▪ `}{`[prop: `}<em parentName="p">{`string`}</em>{`]`}{`: `}<em parentName="p">{`any`}</em></p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "_obj"
    }}>{`_`}{`obj`}</h3>
    <p>{`• `}<strong parentName="p">{`_`}{`obj`}</strong>{`: `}<em parentName="p">{`string`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      